import React from 'react';
import PropTypes from 'prop-types';
import { Banner } from '@els/els-react--banner';
import { ButtonWithIcon } from '@els/els-react--button';

export const MESSAGE_TEXT =
  'We recommend to filter by Affiliation first and then by Author name. This will save time and improve accuracy.';

function BannerLink({ onClick }) {
  return (
    <ButtonWithIcon type="link" sprite="UpRight" linkIconSize="xs" iconRight onClick={onClick}>
      Open affiliation filter
    </ButtonWithIcon>
  );
}

BannerLink.propTypes = {
  onClick: PropTypes.func.isRequired,
};

function BannerAffiliationLink({ onLinkClick }) {
  return (
    <Banner
      link={<BannerLink onClick={onLinkClick} />}
      isVisible
      className="c-els-banner--filled new-author-checkboxes-dialog__banner-afiiliation-link">
      {MESSAGE_TEXT}
    </Banner>
  );
}

BannerAffiliationLink.propTypes = {
  onLinkClick: PropTypes.func.isRequired,
};

export default BannerAffiliationLink;
